import axios from 'axios';

axios.defaults.params = {
    addAddress: window.addAddress,
    addBCC: window.addBCC,
    link: window.location.href
};
